// extracted by mini-css-extract-plugin
export default {"container":"HeaderSide_container__ALYhY","headerSide":"HeaderSide_headerSide__2m0+4","arrow":"HeaderSide_arrow__I+cpE"};